import {FC, useContext, useEffect, useState} from 'react'
import i18n from 'i18next'
import axios from 'axios'
import {FundCatalog} from '../types/FundCatalog'
import {ILanguage} from '../types/common'
import FundTable from '../common/FundTable'
import {FioFundCatalogContext} from './ctx/FioFundCatalogContext'
import {Fund} from '../types/Fund'
import ComparedFundTable from '../common/ComparedFundTable'
import {useTranslation} from 'react-i18next'
import {format} from 'date-fns'

const LayoutFIO: FC<{
    language: ILanguage
}> = ({language}) => {
    const {t} = useTranslation()
    const [tableData, setTableData] = useState<Fund[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const localCtx: any = useContext(FioFundCatalogContext)
    const dynamicColumns: object = {
        oneDay: {value: '1D', label: '1D'},
        oneMonth: {value: '1M', label: '1M'},
        threeMonths: {value: '3M', label: '3M'},
        sixMonths: {value: '6M', label: '6M'},
        oneYear: {value: '12M', label: '12M'},
        threeYears: {value: '36M', label: '36M'},
        fiveYears: {value: '60M', label: '60M'},
        yearToDate: {value: 'YTD', label: 'YTD'},
        max: {value: 'MAX', label: 'MAX'},
    }

    useEffect(() => {
        const params = new URLSearchParams()

        if (localCtx.date) {
            params.append('date', format(localCtx.date, 'yyyy-MM-dd'))
        }

        axios
            .get<FundCatalog>(
                `${process.env.REACT_APP_API_BASE_URL}/api/fund?kind=fio${params.size || [...params.keys()].length ? '&' + params.toString() : ''}`,
                {
                    headers: {
                        Accept: 'application/json',
                    },
                    auth: {
                        username: `${process.env.REACT_APP_API_USERNAME}`,
                        password: `${process.env.REACT_APP_API_PASSWORD}`,
                    },
                }
            )
            .then((result) => {
                const today: Date = new Date(result.data.today)
                let begin: Date = new Date(2100, 0, 1)
                let end: Date = new Date(1900, 0, 1)
                const items: Fund[] = result.data.items
                const holiday = result.data.holiday.map((item) => {
                    return new Date(item)
                })

                items.forEach((item) => {
                    if (begin > new Date(item.begin)) {
                        begin = new Date(item.begin)
                    }
                })

                items.forEach((item) => {
                    if (end < new Date(item.end)) {
                        end = new Date(item.end)
                    }
                })

                localCtx.setMinDate(begin)
                localCtx.setMaxDate(end)
                localCtx.setToday(today)
                localCtx.setHoliday(holiday)

                setTableData(items)
                setIsLoading(false)
            })
            .catch((error) => {
                console.error(error)
            })
    }, [localCtx.date])

    useEffect(() => {
        if (localCtx.compared.length > 0 || localCtx.chartItems.length > 0) {
            const ids = tableData.map((item: Fund) => {
                return item.id
            })

            const compared: Array<string> = localCtx.compared.filter((item: string) => {
                return ids.includes(item)
            })

            if(localCtx.compared.length > 0) {
                localCtx.setCompared(compared)
                if(localCtx.chartItems.length > 0) {
                    localCtx.setChartItems(() => localCtx.chartItems.filter((item: string) => {
                        return compared.includes(item)
                    }))
                }
            } else {
                localCtx.setChartItems([]);
            }
        }
    }, [tableData]);

    useEffect(() => {
        i18n.changeLanguage(language)
    }, [language])

    return (
        <>
            <section id="fund-list">
                <div className="tabs">
                    <div className="tabs-up">
                        <div className="tabs-bar">
                            <ul className="nav">
                                <li
                                    className={localCtx.activeTab === 'catalog' ? 'catalogTab active' : 'catalogTab'}
                                    onClick={() => localCtx.setActiveTab('catalog')}>
                                    {t('label.catalog.tab.fio')}
                                </li>
                                <li
                                    className={localCtx.activeTab === 'compared' ? 'catalogTab active' : 'catalogTab'}
                                    onClick={() => localCtx.setActiveTab('compared')}>
                                    {t('label.catalog.tab.common', {count: localCtx.compared?.length})}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="tabs-content"></div>
                </div>
                <div className="rwdShutter">
                    <div className="navOfflineBlock">
                        <div className="navOfflineLogo"></div>
                    </div>
                    <div className="contentOfflineBlock">
                        {/* <div className="contentOfflineInfo">
            <p>Rozdzielczość Twojego urządzenia jest&nbsp;zbyt niska.<br></br> Obróć&nbsp;ekran lub&nbsp;powiększ okno
                przeglądarki.</p>
        </div> */}
                    </div>
                    {/* <footer className="footerOffline">
        <div>© Allianz </div>
    </footer> */}
                </div>
            </section>
            <div className={'content'}>
                {localCtx.activeTab === 'catalog' && (
                    <FundTable
                        mode={'checkbox'}
                        language={language}
                        data={tableData}
                        isLoading={isLoading}
                        ctx={localCtx}
                        dynamicColumns={dynamicColumns}
                    />
                )}
            </div>
            <div className={'content'}>
                {localCtx.activeTab === 'compared' && (
                    <>
                        <ComparedFundTable
                            language={language}
                            data={tableData}
                            ctx={localCtx}
                            dynamicColumns={dynamicColumns}
                        />
                    </>
                )}
            </div>
        </>
    )
}

export default LayoutFIO
